import React from 'react'
import SpaseXLogo from '../images/SpaceX-Logo.svg'

function StartPage() {
  return (
    <div className='startPage'>
        <img className='startPage__img' src={SpaseXLogo} alt='name'/>
    </div>
  )
}

export default StartPage